import { IProperty } from "src/components/Properties/types";
import minInvest from "src/assets/icons/min-invest.svg";
import listPrice from "src/assets/icons/list-price.svg";
import industry from "src/assets/icons/industry.svg";
import businessType from "src/assets/icons/business-type.svg";
import employees from "src/assets/icons/employees.svg";
import yearsMarket from "src/assets/icons/years-market.svg";
import numbersCustomers from "src/assets/icons/numbers-customers.svg";
import annualTurnover from "src/assets/icons/annual-turnover.svg";
import monthlyIncome from "src/assets/icons/monthly-income.svg";
import { IClone } from "src/@types/clones";

const CURRENCY = "$";

export const getPropertiesClone = (clone: IClone): IProperty[] => [
  {
    label: "Min. Inv.",
    value: `${CURRENCY} ${clone.investment_for_start.toLocaleString()}`,
    icon: {
      url: minInvest,
      title: "",
    },
  },
  {
    label: "List Price",
    value: `${CURRENCY} ${clone.clone_cost.toLocaleString()}`,
    icon: {
      url: listPrice,
      title: "",
    },
  },
  {
    label: "Industry",
    value: `${clone.industry.title}`,
    icon: {
      url: industry,
      title: "",
    },
  },
  {
    label: "Business Type",
    value: `${clone.clone_type.title}`,
    icon: {
      url: businessType,
      title: "",
    },
  },
  {
    label: "Employees",
    value: clone.employees,
    icon: {
      url: employees,
      title: "",
    },
  },
  {
    label: "Years on the market",
    value: clone.years_on_market,
    icon: {
      url: yearsMarket,
      title: "",
    },
  },
  {
    label: "№ of customers",
    value: clone.customers_count,
    icon: {
      url: numbersCustomers,
      title: "",
    },
  },
  {
    label: "Annual Turnover",
    value: `${CURRENCY} ${clone.company_turnover_min.toLocaleString()} - ${CURRENCY} ${clone.company_turnover_max.toLocaleString()}`,
    icon: {
      url: annualTurnover,
      title: "",
    },
  },
  {
    label: "Monthly Income",
    value: `${CURRENCY} ${clone.monthly_income_min.toLocaleString()} - ${CURRENCY} ${clone.monthly_income_max.toLocaleString()}`,
    icon: {
      url: monthlyIncome,
      title: "",
    },
  }
];